// Single source of truth for invoice status strings returned by the API.
// Using the enum (instead of bare literals) prevents a silent typo from
// breaking status-dependent logic such as ecommerce purchase tracking.
export enum InvoiceStatus {
  ACTIVE = "active",
  WAITING = "waiting",
  // Default shown before a payment method is picked (no coin/network yet).
  WAITING_METHOD = "waiting-method",
  SUCCESS = "success",
  ARCHIVED = "archived",
  EXPIRED = "expired",
  CANCELED = "canceled",
}
